import React, { useMemo } from "react";
import { motion, useReducedMotion } from "framer-motion";

// Subtle scroll-reveal wrapper. Respects prefers-reduced-motion.
// Animation configs are module constants so they keep a stable identity
// across renders (avoids re-triggering framer-motion diffing).
const REVEAL_INITIAL = { opacity: 0, y: 14 };
const REVEAL_IN_VIEW = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, amount: 0.2 };
const REVEAL_EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const reduce = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  // Only the delay varies per instance; memoise so the object is stable per delay.
  const transition = useMemo(() => ({ duration: 0.4, delay, ease: REVEAL_EASE }), [delay]);

  if (reduce) {
    const Tag = as;
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <MotionTag
      className={className}
      initial={REVEAL_INITIAL}
      whileInView={REVEAL_IN_VIEW}
      viewport={REVEAL_VIEWPORT}
      transition={transition}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
